import * as S from './styles';
import {
  IProps,
  IMarkProps,
  ITrackProps,
  IProductAttributesValues,
} from './types';


/**
 * Converts and sorts an array of product attribute value objects into an array of numbers.
 * Filters values to only include those divisible by 100 if the onlyDivisibleBy100 flag is true.
 * Specifically includes 450 and 550 if they are present in the original attributeValues.
 *
 * @param attributeValues - Array of product attribute value objects
 * @param onlyDivisibleBy100 - Optional flag to filter values to those divisible by 100
 * @returns Sorted array of numeric values extracted from the attributeValues array, conditionally including 450 and 550
 */
/**
 * Converts and sorts an array of product attribute value objects into an array of numbers.
 * Filters values to only include those divisible by 100 if the onlyDivisibleBy100 flag is true.
 * Specifically includes 450 and 550 if they are present in the original attributeValues.
 *
 * @param attributeValues - Array of product attribute value objects
 * @param onlyDivisibleBy100 - Optional flag to filter values to those divisible by 100
 * @returns Sorted array of numeric values extracted from the attributeValues array, conditionally including 450 and 550
 */
function convertAndSortValues(
  attributeValues: IProductAttributesValues[],
  onlyDivisibleBy100 = false
): number[] {
  const sortedValues = attributeValues
    .filter((v) => v) // Ensure the object exists
    .map((item) => parseInt(item.value, 10)) // Convert each 'value' property to an integer
    .filter((value) => (!onlyDivisibleBy100 || value % 100 === 0) || value === 450 || value === 550)
    .sort((a, b) => a - b); // Sort the array of integers in ascending order

  return sortedValues;
}


/**
 * Finds the slug value corresponding to the given target value.
 * Searches through the provided list of attribute values to find the object
 * where the 'value' property matches the targetValue.
 * Returns the 'slug' property of the matching object if found, otherwise undefined.
 */
function findSlugByValue(
  attributeValues: IProductAttributesValues[],
  targetValue: number
): string | undefined {
  // Find the object where 'value' matches the given number
  const matchingObject = attributeValues.find(
    (item) => parseInt(item.value, 10) === targetValue
  );

  // Return the 'slug' value if the object is found
  return matchingObject?.slug;
}

const Track: React.FC<ITrackProps> = (props) => <S.Track {...props} />;

const Mark: React.FC<IMarkProps> = (props) => <S.Mark {...props} />;

export const Slider: React.FC<IProps> = ({
  values,
  onChange,
  value,
  compactView,
}: IProps) => {
  const valuesArray = convertAndSortValues(values, compactView);
  const sliderMin = 0;
  const sliderMax = valuesArray.length - 1;
  const sliderIndex = valuesArray.indexOf(parseInt(value, 10));
  const onChangeHandler = (newValue: number) => {
    const newSlug = valuesArray[newValue];
    onChange(findSlugByValue(values, newSlug));
  };

  // Function to generate marks
  const generateMarks = (min: number, max: number, interval: number) => {
    const numberOfMarks = Math.floor((max - min) / interval) + 1;
    return Array.from({ length: numberOfMarks }, (_, i) => min + i * interval);
  };

  const marks = generateMarks(sliderMin, sliderMax, 10);

  return (
    <S.Slider
      min={sliderMin}
      max={sliderMax}
      onChange={onChangeHandler}
      value={sliderIndex}
      marks={sliderMax < 15 || marks}
      renderMark={(props) => (
        <Mark {...props} active={props.key <= sliderIndex} />
      )}
      renderTrack={(props, state) => <Track {...props} index={state.index} />}
      renderThumb={(props, state) => (
        <div {...props}>
          <S.ThumbWrapper>
            {/* state.valueNow > sliderMin && (
              <S.ThumbButton
                onClick={() => onChangeHandler(Math.max(state.valueNow - 1, 0))}
                minus
              >
                <span>&#65293;</span>
              </S.ThumbButton>
            ) */}
            <S.ThumbLabel>{`${
              valuesArray[state.valueNow] / 10
            }cm`}</S.ThumbLabel>
            {/* state.valueNow < sliderMax && (
              <S.ThumbButton
                onClick={() =>
                  onChangeHandler(Math.min(state.valueNow + 1, sliderMax))
                }
                minus={false}
              >
                <span>&#65291;</span>
              </S.ThumbButton>
              ) */}
          </S.ThumbWrapper>
        </div>
      )}
    />
  );
};
